import {
  LocalUser,
  RemoteUser,
  useIsConnected,
  useJoin,
  useLocalMicrophoneTrack,
  useLocalCameraTrack,
  usePublish,
  useRemoteUsers,
  useLocalScreenTrack,
  LocalVideoTrack,
} from "agora-rtc-react";
import {
  ArrowLeft,
  Book,
  Book1,
  CallRemove,
  Document,
  DocumentDownload,
  Edit,
  Eye,
  Messages,
  Microphone,
  MicrophoneSlash,
  More,
  Profile,
  Profile2User,
  Screenmirroring,
  SearchNormal1,
  Send,
  Send2,
  Sms,
  UserAdd,
  UserCirlceAdd,
  Video,
  VideoSlash,
} from "iconsax-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ArrowUp, X } from "lucide-react";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import instance, { frontUrl, url } from "../../../../axios/instance";
import { toast } from "react-toastify";
import { SocketContext } from "../context/SocketContext";
import formatTimestamp from "../utils/format_timestamp";
import { getToken } from "../../../../utils/token";
import { formatDuration, MeetingChat, meetingFormatDate, ParticipantList } from "./InstantMeetingRoom";
import useConferenceDuration from "../hooks/useConferenceDuration";
import Draggable from "react-draggable";
import formatDate from "../../../../utils/formatDate";
import truncateText from "../utils/truncate_text";


export default function MeetingRoom({ token, meetingData }) {
  // const user = useContext(UserContext)

  const [loading, setLoading] = useState(false);
  const [screenShareOn, setScreenShareOn] = useState(false);
  const [viewParticipants, setViewParticipants] = useState(false);
  const [viewInviteLink, setViewInviteLink] = useState(false);
  const [isNoteOpen, setIsNoteOpen] = useState(true);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const navigate = useNavigate();

  console.log("Meeting screen", meetingData);

  const [micOn, setMic] = useState(false);
  const [cameraOn, setCamera] = useState(false);
  const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn, {
    AEC: true,
    ANS: true,
    AGC: true,
  });
  const { localCameraTrack } = useLocalCameraTrack(cameraOn);
  const [calling, setCalling] = useState(true);
  const { screenTrack, error } = useLocalScreenTrack(
    screenShareOn,
    {},
    "disable"
  );
  usePublish([localMicrophoneTrack, localCameraTrack, screenTrack]);

  const inviteLink = `${frontUrl}/telemedicine/meeting/invite/guest/${meetingData.meeting.id}`;

  // production url: https://nova.careapps.net/telemedicine/meeting/invite/guest/${meetingData.meeting.id}

  const remoteUsers = useRemoteUsers();

  // trigger message notif
  const [messageNotif, setMessageNotif] = useState(false);

  const user = useLoaderData()

  // this is the main one
  useJoin(
    {
      uid: meetingData.meeting.doctor_id,
      appid: "df936d67e3aa4a44829bb8ecff6e33bc",
      channel: meetingData.meeting.channel_name,
      token: token,
    },
    calling
  );

  const duration = useConferenceDuration(calling)

  function handleNoteDisplay() {
    setIsNoteOpen(!isNoteOpen);
  }

  function handleChatDisplay() {
    setMessageNotif(false);
    setIsChatOpen(!isChatOpen);
  }

  async function handleEndMeeting() {
    console.log(meetingData.meeting.id);

    instance
      .post(
        "/telemedicine/meeting/end",
        {
          meeting_id: meetingData.meeting.id,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        setCalling(false);
        navigate("/dashboard/telemedicine");
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
    // ask are you sure first do this when user tries to refresh browser too
    // setCalling(false)
    // navigate("/dashboard/telemedicine")
  }

  function handleScreenSharing() {
    console.log("share screen");
    if (screenShareOn) {
      setScreenShareOn(false);
    } else {
      setScreenShareOn(true);
    }
  }

  function copyInviteLink() {
    navigator.clipboard
      .writeText(inviteLink)
      .then(() => {
        toast.success("Invite link copied", {
          position: "bottom-right",
        });
      })
      .catch((err) => {
        toast.error("Failed to copy link", {
          position: "bottom-right",
        });
      });
  }

  function tesFunc() {
    console.log(screenTrack);
  }

  // audio logic start
  const [micInstance, setMicInstance] = useState(false); // mic is off my default
  // Mute local audio
  const muteLocalAudio = (audioTrack) => {
    if (!audioTrack) return;
    audioTrack.setVolume(0);
  };

  // Unmute local audio
  const unmuteLocalAudio = (audioTrack) => {
    if (!audioTrack) return;
    audioTrack.setVolume(100); // Set the volume to a reasonable volume level
  };
  // audio logic end

  // vidio logic start
  const [videoInstance, setVideoInstance] = useState(false); // video is off my default
  const turnOffLocalVideo = (videoTrack) => {
    if (!videoTrack) return;
    videoTrack.setEnabled(false);
  };

  // Unmute local video
  const turnOnLocalVideoo = (videoTrack) => {
    if (!videoTrack) return;
    videoTrack.setEnabled(true);
  };
  // video logic end

  if (loading) {
    return <div>loading call</div>;
  }

  return (
    <div className="bg-[#20232b] h-[100svh]">
      <div className="py-3 px-5 h-[10%] lg:hidden gap-3 flex items-center justify-between bg-[#20232b]">
        <div>
          <div className="text-gray-300 text-[10px] mb-[2px]">{meetingFormatDate()}</div>
          <div className="text-[#fafafa] text-[12px] font-medium">Instant Meeting</div>
        </div>

        <div className="text-[#fafafa] font-medium text-[12px]">{formatDuration(duration)}</div>
      </div>
      {/* <LocalVideoTrack track={screenTrack} play style={{ width: "300px", height: "300px" }} /> */}
      <div className="bg-[#20232b] h-[80%] lg:h-[90%]">
        {/* we will render UI with certain conditions */}

        {/* Condition 1 - if sharing screen is active */}
        {screenShareOn ? (
          <div className="grid grid-cols-12 w-full h-full">
            <div className="col-span-9 p-4">
              <div className="w-full h-full bg-black">
                <LocalVideoTrack
                  track={screenTrack}
                  play
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>

            <div className="col-span-3 overflow-y-scroll border-l max-h-[100%] bg-white">
              <div className="sticky top-0 left-0 right-0 bg-white px-3 py-3">
                <div className="font-medium">
                  Meeting Participants ({remoteUsers.length + 1})
                </div>
              </div>

              <div className="px-4 py-3 space-y-3">
                {/* local user cam */}
                <div className="w-full h-[200px] z-[100]">
                  {!cameraOn || !videoInstance ? (
                    <LocalUserCameraOff />
                  ) : (
                    <LocalUser
                      //audioTrack={localMicrophoneTrack}
                      cameraOn={cameraOn}
                      micOn={micOn}
                      videoTrack={localCameraTrack}
                    />
                  )}
                </div>
                {/* local user cam */}
                {remoteUsers.map((user) => (
                  <div key={user.uid} className="w-full h-[200px]">
                    <RemoteUser user={user} />
                  </div>
                ))}

                {/* <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div>
                                <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div>
                                <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div> */}
              </div>
            </div>
          </div>
        ) :

          // condition 1.5 - if there is only 1 person in the meeting
          remoteUsers.length < 1 ?
            <div className="w-full h-full flex justify-center items-center relative">
              <div className="lg:w-[80%] lg:h-[90%] w-[90%] h-[50%] rounded-[10px] overflow-hidden">
                {
                  // !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                  <LocalUser
                    cameraOn={cameraOn}
                    micOn={micOn}
                    videoTrack={localCameraTrack}
                  >
                    <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{user.prefix} {user.firstname} {user.lastname} (You)</div>
                  </LocalUser>
                }
              </div>
            </div> :

            /* Condition 2 - if there are only 2 participants */
            remoteUsers.length < 2 ?
              <div className="w-full h-full relative flex flex-col lg:flex-row-reverse lg:px-10 items-center gap-4 lg:gap-8 justify-center">
                <Draggable>
                  <div className="lg:w-[300px] lg:h-[200px] w-[90%] h-[50%] rounded-[8px] overflow-hidden z-[100]">
                    {
                      // !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                      <LocalUser
                        cameraOn={cameraOn}
                        micOn={micOn}
                        videoTrack={localCameraTrack}

                      >
                        <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{user.prefix} {user.firstname} {user.lastname} (You)</div>
                      </LocalUser>
                    }
                  </div>
                </Draggable>

                <div className="lg:w-[80%] lg:h-[90%] w-[90%] h-[50%] rounded-[10px] overflow-hidden">
                  <RemoteUser user={remoteUsers[0]}>
                    <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{remoteUsers[0].uid}</div>
                  </RemoteUser>
                </div>
              </div> : (
                /* Condition 3 - if there are more than 2 participants */
                <div className="w-full h-full flex flex-wrap gap-3 overflow-y-scroll justify-center items-center lg:p-4">
                  {/* local user cam */}
                  <div className="col-span-6 rounded-[10px] overflow-hidden min-w-[90%] lg:min-w-[40%] h-[50%] z-[100]">
                    {
                      // !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                      <LocalUser
                        cameraOn={cameraOn}
                        micOn={micOn}
                        videoTrack={localCameraTrack}
                      >
                        <div className={`w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end`}>{user.prefix} {user.firstname} {user.lastname} (You)</div>
                      </LocalUser>
                    }

                  </div>
                  {/* local user cam */}
                  {
                    remoteUsers.map(user => (
                      <div key={user.uid} className="col-span-6 rounded-[10px] overflow-hidden max-w-[90%] lg:max-w-[40%] min-w-[90%] lg:min-w-[40%] flex-1  h-[50%]">
                        <RemoteUser user={user}>
                          <div className="w-full h-full p-4 text-gray-100 text-[13px] flex justify-start items-end">{user.uid}</div>
                        </RemoteUser>
                      </div>
                    ))
                  }



                </div>
              )}
      </div>



      <div className="py-3 px-5 h-[10%] gap-3 flex items-center justify-center lg:justify-between bg-[#20232b]">
        <div className="lg:block hidden">
          <div className="text-gray-300 text-[10px] mb-[2px]">{meetingFormatDate()}</div>
          <div className="text-[#fafafa] text-[12px] font-medium">Appointment - {user.id}</div>
        </div>

        <div className="flex justify-center items-center gap-3">
          <button onClick={() => {
            if (micInstance) {
              setMicInstance(false)
              setMic(false)
              muteLocalAudio(localMicrophoneTrack)
            } else {
              setMicInstance(true)
              setMic(true)
              unmuteLocalAudio(localMicrophoneTrack)
            }
          }} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
            {
              !micInstance || !micOn ?
                <MicrophoneSlash size={20} color="#00b0ad" variant="Bold" /> :
                <Microphone size={20} color="#00b0ad" variant="Bold" />
            }
          </button>

          <button onClick={() => {
            if (videoInstance) {
              setVideoInstance(false)
              setCamera(false)
              turnOffLocalVideo(localCameraTrack)
            } else {
              setVideoInstance(true)
              setCamera(true)
              turnOnLocalVideoo(localCameraTrack)
            }
          }} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
            {
              !videoInstance || !cameraOn ?
                <VideoSlash size={20} color="#00b0ad" variant="Bold" /> :
                <Video size={20} color="#00b0ad" variant="Bold" />
            }
          </button>

          <button onClick={handleScreenSharing} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
            <ArrowUp size={20} width="20px" height="20px" color="#00b0ad" variant="Bold" />
          </button>

          <button onClick={handleChatDisplay} className={`w-10 h-10 relative rounded-full ${!isChatOpen ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} flex justify-center items-center`}>
            <Messages size={20} color={!isChatOpen ? "#00b0ad" : "#fff"} variant="Bold" />
            {
              messageNotif ?
                <div className="bg-red-500 w-3 h-3 top-0 right-0 absolute z-[1000] rounded-full"></div> : null
            }
          </button>

          <button
            onClick={handleNoteDisplay}
            className={`w-10 h-10 rounded-full ${!isNoteOpen ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"
              } flex justify-center items-center`}
          >
            <Document
              size={20}
              color={!isNoteOpen ? "#00b0ad" : "#fff"}
              variant="Bold"
            />
          </button>


          <div className="relative">
            <ParticipantList currentUser={`${user.prefix} ${user.firstname} ${user.lastname}`} participants={remoteUsers} isModalOpen={viewParticipants} onModalClose={() => setViewParticipants(false)} />
            <button onClick={() => setViewParticipants(!viewParticipants)} className={`w-10 h-10 rounded-full ${!viewParticipants ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} flex justify-center items-center`}>
              <Profile2User size={20} color={!viewParticipants ? "#00b0ad" : "#fff"} variant="Bold" />
            </button>
          </div>

          {/* <div className="relative">
            <div
              className={`${!viewInviteLink ? "hidden" : "block"
                } border bg-white z-[1000] w-[350px] absolute bottom-[70px] rounded-[8px] p-3 space-y-3`}
            >
              <div className="font-medium text-[15px]">Invite Participants</div>

              <div className="space-y-2">
                <div className="flex w-full rounded-[4px] gap-1">
                  <input
                    className="p-3 bg-[#f1f1f1] flex-1 text-gray-500 text-[14px] rounded-[6px]"
                    defaultValue={inviteLink}
                    disabled
                  />
                  <button
                    onClick={copyInviteLink}
                    className="bg-[#00b0ad] rounded-[6px] text-[14px] px-3 font-semibold text-white"
                  >
                    Copy link
                  </button>
                </div>
              </div>
            </div>
            <button
              onClick={() => setViewInviteLink(!viewInviteLink)}
              className={`w-10 h-10 rounded-full ${!viewInviteLink ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"
                } flex justify-center items-center`}
            >
              <Add
                size={18}
                color={!viewInviteLink ? "#00b0ad" : "#fff"}
                variant="Bold"
              />
            </button>
          </div> */}


          <button onClick={handleEndMeeting} className="w-10 h-10 rounded-full bg-red-500 flex justify-center items-center">
            <CallRemove size={20} color="#fff" variant="Bold" />
          </button>
        </div>

        <div className="text-[#fafafa] font-medium text-[12px] lg:block hidden">{formatDuration(duration)}</div>
      </div>




      <MeetingNote
        defaultNoteTitle={meetingData.meeting.meeting_title}
        patientID={meetingData.meeting.patient_id}
        isNoteOpen={isNoteOpen}
        onNoteClose={() => setIsNoteOpen(false)}
      />

      <MeetingChat
        roomID={meetingData.meeting.id}
        isChatOpen={isChatOpen}
        onChatClose={() => setIsChatOpen(false)}
        participantName={meetingData.meeting.doctor_name}
        messageNotif={(data) => {
          if (data) {
            setMessageNotif(true);
          }
        }}
      />
    </div>
  );
}

function MeetingNote({ isNoteOpen, onNoteClose, defaultNoteTitle, patientID }) {

  const [title, setTitle] = useState("");
  const [notes, setNotes] = useState("");
  const [currentNote, setCurrentNote] = useState([])
  const [isNewNoteSaved, setIsNewNoteSaved] = useState({
    saved: false,
    noteId: ""
  })
  const [openPreviousNotes, setOpenPreviousNotes] = useState(false)

  const [patientNotes, setPatientNotes] = useState([]);

  const [notesLoading, setNotesLoading] = useState(false);

  const token = window.sessionStorage.getItem("ACCESS_TOKEN");

  function handleTitle(event) {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
    setTitle(event.target.value);
  }

  function handleNotes(event) {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
    setNotes(event.target.value);
  }


  async function getNotes() {
    setNotesLoading(true);
    instance
      .post(
        "/telemedicine/doctor/get_notes",
        {
          patient_id: patientID,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("notes are", response.data);
        setPatientNotes(response.data);
        setNotesLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });
        setPatientNotes([]);
        setNotesLoading(false);
      });
  }

  async function addNote() {
    instance
      .post(
        "/telemedicine/doctor/note",
        {
          patient_id: patientID,
          note_title: title,
          note: notes,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("notes are", response.data);
        getNotes();
        setNotesLoading(false);
        setIsNewNoteSaved({
          saved: true,
          noteId: response.data.noteId
        })
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });

        setNotesLoading(false);
      });
  }

  async function getCurrentNote() {
    instance
      .post(
        "/telemedicine/doctor/current_note",
        {
          patient_id: patientID,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log("notes are", response.data);
        const currentNote = response.data

        if (currentNote.length < 1) {
          console.log("There is no note currently");
          setCurrentNote("")
          setTitle("")
          setNotes("")

        } else {
          console.log("There is a note");
          setCurrentNote(currentNote[0])
          setTitle(currentNote[0].note_title)
          setNotes(currentNote[0].note)
          console.log("there", currentNote[0]);

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function updateNote(id) {
    instance
      .post(
        "/telemedicine/doctor/note/update",
        {
          note_id: id,
          note_title: title,
          note: notes,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        getNotes();
        getCurrentNote()
        setNotesLoading(false);
        toast.success("note updated")
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });

        setNotesLoading(false);
      });
  }

  useEffect(() => {
    getNotes();
    getCurrentNote()
  }, []);


  return (
    <>
      <div className={`${!isNoteOpen ? "hidden" : "block"} z-[100] fixed top-0 bottom-0 left-0 right-0 bg-[#11111180]`} />
      <div
        className={`${isNoteOpen ? "right-0" : "right-[-600px]"
          } transition-all bg-[#20232b] z-[3000] fixed top-0 bottom-0 right-0 w-[600px]`}
      >

        {notesLoading ? (
          <div>Loading notes</div>
        ) : (
          <>
            <div className="flex justify-between p-3 items-center">
              <div className="font-medium text-[14px] text-[#fafafa]">Notes</div>
              <button onClick={onNoteClose}>
                <X size={20} color="#fafafa" />
              </button>
            </div>

            <div className="p-3 flex flex-col">
              {
                currentNote?.updated_at && <div className="text-[12px] text-gray-400">Last updated: {formatDate(currentNote?.updated_at)}</div>
              }

              <textarea
                value={title}
                onChange={handleTitle}
                placeholder="Title"
                aria-multiline
                className="resize-none bg-inherit text-[#fafafa] text-[20px] outline-none font-semibold w-full"
              />
              <textarea
                value={notes}
                onChange={handleNotes}
                placeholder="Take a note..."
                aria-multiline
                className="resize-none bg-inherit text-[#fafafa] text-[15px] outline-none font-normal w-full"
              />
            </div>


            {
              openPreviousNotes && <PreviousNotes onClose={() => setOpenPreviousNotes(false)} patientNotes={patientNotes} />
            }

            <button onClick={() => setOpenPreviousNotes(!openPreviousNotes)} className="text-[#fafafa] px-6 flex items-center gap-2 text-sm shadow-sm py-2 text-[14px] rounded-[6px] absolute bottom-3 left-0">
              <ArrowLeft size={20} />
              Previous notes
            </button>
            {

              !currentNote && !isNewNoteSaved.saved ?
                <button
                  onClick={addNote}
                  className="bg-[#00b0ad] text-white px-6 shadow-sm py-2 text-[14px] font-medium rounded-[6px] absolute bottom-3 right-3"
                >
                  Save note
                </button> :
                <button
                  onClick={() => updateNote(currentNote?.id || isNewNoteSaved.noteId)}
                  className="bg-[#00b0ad] text-white px-6 shadow-sm py-2 text-[14px] font-medium rounded-[6px] absolute bottom-3 right-3"
                >
                  Update note
                </button>
            }


          </>
        )}
      </div>
    </>
  );
}

function PreviousNotes({ patientNotes, onClose }) {

  const [openNote, setOpenNote] = useState({
    open: false,
    noteId: ""
  })

  return (
    <>
      {
        openNote.open && <EditPreviousNoteModal onClose={() => setOpenNote({
          open: false,
          noteId: ""
        })} noteId={openNote.noteId} />
      }
      <div className="p-3 space-y-3 absolute bottom-0 w-[450px] h-[80%] rounded-t-[8px] right-[620px] bg-[#20232b]">
        <div className="font-medium text-[14px] text-[#fafafa] flex justify-between items-center">
          Previous Notes
          <X onClick={onClose} className="cursor-pointer" size={16} color="#fafafa" />
        </div>

        {patientNotes.length < 1 ? (
          <div className="text-gray-500">
            No recent note for this patient
          </div>
        ) : (
          patientNotes.map((note) => (
            <div onClick={() => {
              setOpenNote({
                open: true,
                noteId: note.id
              })
            }} className="flex w-full cursor-pointer gap-3">
              <div className="border  hover:bg-[#16181c] transition-all border-gray-600 rounded-[8px] flex-1 shadow-sm p-3 space-y-6">
                <div className="space-y-1">
                  <div className="flex justify-between items-center">
                    <div className="font-semibold text-[#fafafa] text-[15px]">
                      <div className="text-[12px] text-gray-400 font-normal">Last updated: {formatDate(note.updated_at)}</div>
                      {note.note_title}
                    </div>
                  </div>
                  {/* <div className="font-semibold text-[15px]">{note.note_title}</div> */}
                  <div className="text-[14px] text-[#fafafa]">
                    {truncateText(note.note, 120)}
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <div>
                    <div className="text-[12px] text-gray-400">
                      Created: {formatDate(note.created_at)} by {note.doctor_name}
                    </div>
                  </div>

                  {/* <div className="flex gap-2 items-center">
                  <button className="w-6 h-6 bg-[#00b0ad] flex justify-center items-center rounded-full">
                    <Edit size={16} variant="Bold" color="#fff" />
                  </button>

                  <button className="w-6 h-6 bg-[#00b0ad] flex justify-center items-center rounded-full">
                    <DocumentDownload
                      size={16}
                      variant="Bold"
                      color="#fff"
                    />
                  </button>
                </div> */}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  )
}

function EditPreviousNoteModal({ noteId, onClose }) {

  const [loading, setLoading] = useState(false)
  const [note, setNote] = useState("")
  const [title, setTitle] = useState("")
  const [noteDoctor, setNoteDoctor] = useState("")

  const user = useLoaderData()

  function handleTitle(event) {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
    setTitle(event.target.value);
  }

  function handleNotes(event) {
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
    setNote(event.target.value);
  }

  // get latest note data
  async function getCurrentNote() {
    setLoading(true)
    instance
      .get(
        `/telemedicine/doctor/note/${noteId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((response) => {
        setNote(response.data.note)
        setTitle(response.data.note_title)
        setNoteDoctor(response.data.doctor_id)
        setLoading(false)
      })
      .catch((error) => {
        console.log(error);
        setLoading(false)
      });
  }

   async function updateNote() {
    instance
      .post(
        "/telemedicine/doctor/note/update",
        {
          note_id: noteId,
          note_title: title,
          note: note,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      )
      .then((response) => {
        // getNotes();
        // getCurrentNote()
        // setNotesLoading(false);
        toast.success("note updated")
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });

        //setNotesLoading(false);
      });
  }

  useEffect(() => {
    getCurrentNote()
  }, [noteId])

  return (
    <div className="fixed top-0 flex justify-center items-center left-0 bottom-0 right-0 z-[3100] bg-[#11111180]">
      <div className="w-[550px] flex flex-col h-[70%] bg-[#20232b] rounded-[8px]">
        <div className="font-medium text-[14px] p-3 text-[#fafafa] flex justify-between items-center">
          Edit note
          <X onClick={onClose} className="cursor-pointer" size={20} color="#fafafa" />
        </div>

        {
          user.id !== noteDoctor && <div className="bg-[#dd4b3922] text-[#dd4b39] px-3 py-2 text-[14px] font-normal">You can't edit this note</div>
        }


        <div className="p-3 flex flex-1 flex-col">
          <textarea
            value={title}
            onChange={handleTitle}
            disabled={user.id !== noteDoctor}
            placeholder="Title"
            aria-multiline
            className="resize-none bg-inherit text-[#fafafa] text-[16px] outline-none font-semibold w-full"
          />

          <div className="flex flex-1 flex-col h-[300px] overflow-y-scroll scrollbar-hide">
          <textarea
            value={note}
            onChange={handleNotes}
            disabled={user.id !== noteDoctor}
            placeholder="Take a note..."
            aria-multiline
            className="resize-none bg-inherit flex-1 text-[#fafafa] text-[15px] outline-none font-normal w-full"
          />
          </div>
        </div>

        <div className="p-3 flex justify-end">
          <button onClick={updateNote} className="text-[#00b0ad] text-sm">Save</button>
        </div>
      </div>



    </div>
  )
}

// function MeetingChat({
//   isChatOpen,
//   onChatClose,
//   participantName,
//   roomID,
//   messageNotif,
// }) {
//   const [message, setMessage] = useState("");
//   const socket = useContext(SocketContext);
//   const [messages, setMessages] = useState([]);
//   const messageRef = useRef();

//   function sendMessage() {
//     if (!message) {
//       toast.error("Input field cannot be empty", {
//         position: "bottom-right",
//       });
//     } else {
//       const messageData = {
//         user: participantName,
//         roomID: roomID,
//         message: message,
//         createdAt: Date.now(),
//       };

//       socket.emit("send_meeting_message", messageData);

//       messageRef.current.value = "";
//     }
//   }

//   function getMessages() {
//     // socket.join(roomID)
//     instance
//       .post("/telemedicine/meeting/get_messages", {
//         roomID: roomID,
//       })
//       .then((response) => {
//         console.log(response.data);
//         setMessages(response.data);
//       })
//       .catch((error) => {
//         console.log(error.response.data.message);
//       });
//   }

//   socket.on("meeting_message_sent", (data) => {
//     console.log("meeting_message_sent data is", data);
//     messageNotif(true);
//     setMessages(data.messages);
//   });

//   useEffect(() => {
//     socket.emit("join_meeting_room", { roomID: roomID });
//     getMessages();
//   }, [isChatOpen]);

//   return (
//     <div
//       className={`${isChatOpen ? "right-0" : "right-[-400px]"
//         } border-l transition-all bg-white z-[3000] flex flex-col fixed top-0 bottom-0 right-0 w-[400px]`}
//     >
//       <div className="flex justify-between p-3 items-center border-b">
//         <div className="font-semibold">Chat</div>
//         <button onClick={onChatClose}>
//           <X size={20} />
//         </button>
//       </div>

//       <div className="flex-1 p-3 space-y-3 overflow-y-scroll">
//         {messages.length < 1 ? (
//           <div className="text-gray-500">No recent message</div>
//         ) : (
//           messages?.map((item) => (
//             // <div key={item.id}>{item.message}</div>
//             <SenderBubble
//               key={item.id}
//               name={item.sender_name}
//               message={item.message}
//               time={formatTimestamp(item.created_at)}
//             />
//           ))
//         )}
//       </div>

//       <div className="flex items-center p-3 gap-2 border-t">
//         <input
//           ref={messageRef}
//           onChange={(e) => setMessage(e.target.value)}
//           onKeyUp={(event) => {
//             if (event.key === "Enter") {
//               sendMessage();
//             }
//           }}
//           placeholder="Enter message..."
//           className="py-[10px] px-4 text-[14px] bg-[#f1f1f1] outline-none rounded-full flex-1"
//         />
//         <button
//           onClick={sendMessage}
//           className="h-10 w-10 rounded-full bg-[#00b0ad] flex justify-center items-center"
//         >
//           <Send size={18} variant="Bold" color="#fff" />
//         </button>
//       </div>
//     </div>
//   );
// }

// function SenderBubble({ name, message, time, key }) {
//   return (
//     <div key={key} className="bg-gray-100 p-3 relative">
//       <div className="font-medium text-[13px]">{name}</div>
//       <div className="text-[15px] max-w-[70%]">{message}</div>
//       <div className="text-[12px] absolute right-3 bottom-3">{time}</div>
//     </div>
//   );
// }

// function LocalUserCameraOff() {
//   return (
//     <div className="bg-[#111] w-full h-full flex justify-center items-center">
//       <div className="font-semibold w-10 h-10 rounded-full bg-[#00b0ad] text-white flex justify-center items-center">
//         Me
//       </div>
//     </div>
//   );
// }
